// @flow

/**
 * True when browser Back/Forward lands on the brand switch ("/") of a shop with several brands
 * while a brand's shop is still loaded. "/" then renders that brand's start page, so the brand
 * switch has to be shown again by disabling the config, as the module's own back arrow does
 * (NavigationContainer#pushToBrandSwitchOrElse).
 */
export const isPopToBrandSwitch = (location: {pathname: string}, action: string, config: Object): boolean =>
    action === "POP"
    && location.pathname === "/"
    && !!config.configLoaded
    && !!(config.garageId || config.garageGroupId)
    && !!config.brandInstances && config.brandInstances.length > 1;
